import superagent from 'superagent'
import isNil from 'lodash/isNil'

export const followingSet = following => ({
  type: 'FOLLOWING_SET',
  payload: following
})

export const followCreate = follow => ({
  type: 'FOLLOW_CREATE',
  payload: follow
})

export const followDelete = userId => ({
  type: 'FOLLOW_DELETE',
  payload: userId
})

export const followingFetchRequest = (position = '', list = []) => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI_3__}/UserFollowing/Get?afterPosition=${position}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return
        }
        const updated = list.concat(res.body.results)
        resolve(res.body.results)
        dispatch(followingSet(updated))
        if (res.body.hasAfter) {
          dispatch(followingFetchRequest(res.body.afterCursor.position, updated))
        }
      })
  })
}

export const followCreateRequest = userId => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI_3__}/UserFollowing/Follow?followUserId=${userId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return
        }
        resolve(res.body)
        dispatch(followCreate(res.body))
      })
  })
}

export const followDeleteRequest = userId => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .delete(`${__API_URI_3__}/UserFollowing/Unfollow/${userId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return
        }
        resolve(res.body)
        dispatch(followDelete(userId))
      })
  })
}
